module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "640",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "trackForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tchText))]), _vm._v(" "), (_vm.row && _vm.row.country) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v("· " + _vm._s(_vm.row.country))]) : _vm._e()]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "入职 / 节点日"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.row && _vm.row.hireDate) || '—') + " / " + _vm._s((_vm.row && _vm.row.reviewDue) || '—'))])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "类型",
      "prop": "trackType"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "transfer": "",
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.form.trackType),
      callback: function($$v) {
        _vm.$set(_vm.form, "trackType", $$v)
      },
      expression: "form.trackType"
    }
  }, _vm._l((_vm.trackTypes), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('div', {
    on: {
      "paste": _vm.handleContentPaste
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": 2000,
      "placeholder": "填写回访/跟踪内容，可粘贴图片作为附件"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "上传附件"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$appConfig.baseUrl + '/upload/fileUpload',
      "on-change": _vm.handleTrackFileChange,
      "on-success": _vm.trackFileSuccess,
      "on-progress": _vm.handleProgress,
      "headers": _vm.headers,
      "before-upload": _vm.beforeUploadTrackFile,
      "limit": 5,
      "multiple": "",
      "file-list": _vm.defaultPicsList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload el-icon--left"
  }), _vm._v("上传")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0116a3ae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/modal/ReviewSaveModal.vue
// module id = 1605
// module chunks = 8